
import { useState } from 'react';
import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const headingAnim = useScrollAnimation({ threshold: 0.2 });
  const itemsAnim = useStaggerAnimation(5, { threshold: 0.05 });

  const faqs = [
    {
      question: 'How fast can you build it?',
      answer:
        'Most websites are completed within 1\u20133 weeks, depending on complexity and content readiness. We work efficiently without sacrificing quality.',
    },
    {
      question: 'Do you offer monthly plans?',
      answer:
        'Yes. We offer maintenance plans starting at $125/month and local SEO services from $275/month. All plans include hosting, security, and support.',
    },
    {
      question: 'What do you need from me?',
      answer:
        'Just your business information, any existing branding materials, content (text and images), and your goals. We handle the rest.',
    },
    {
      question: 'Can you update the site later?',
      answer:
        'Absolutely. All maintenance plans include regular content updates. You can also request changes anytime, and we\u2019ll handle them quickly.',
    },
    {
      question: 'Do you guarantee rankings?',
      answer:
        'No one can guarantee specific rankings, but we follow proven SEO best practices and focus on local visibility to help you get found by nearby customers.',
    },
  ];

  return (
    <section className="py-28 bg-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <div
          ref={headingAnim.ref}
          className="text-center mb-16"
          style={{
            opacity: headingAnim.isVisible ? 1 : 0,
            transform: headingAnim.isVisible ? 'translateY(0)' : 'translateY(30px)',
            transition: 'opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1), transform 0.7s cubic-bezier(0.16, 1, 0.3, 1)',
          }}
        >
          <span className="font-inter font-semibold text-xs tracking-widest uppercase text-primary/60 mb-3 block">FAQ</span>
          <h2 className="font-sora font-bold text-4xl lg:text-[44px] text-charcoal leading-tight">
            Common questions
          </h2>
        </div>

        <div ref={itemsAnim.ref} className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`rounded-xl border transition-all duration-300 ${
                openIndex === index
                  ? 'border-gray-200 bg-gray-50 shadow-sm'
                  : 'border-gray-100 bg-white hover:border-gray-200'
              }`}
              style={itemsAnim.getItemStyle(index)}
            >
              <button
                onClick={() =>
                  setOpenIndex(openIndex === index ? null : index)
                }
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <h3 className="font-inter font-semibold text-[15px] text-charcoal pr-4">
                  {faq.question}
                </h3>
                <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                  openIndex === index ? 'bg-charcoal' : 'bg-gray-100'
                }`}>
                  <i
                    className={`ri-arrow-down-s-line text-lg transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180 text-white' : 'text-gray-500'
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p className="font-inter text-sm text-gray-500 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
